module.exports = __webpack_public_path__ + "static/media/66.c1fe57d2.jpg";